import { Typography } from '@mui/material';

import { ContainerH } from '../Container';

/**
 * 페이지 안에서 사용하는 메뉴의 헤더.
 *
 * @package
 */
export const Header = ({ children }: { children?: React.ReactNode }) => {
  return (
    <ContainerH height={56}>
      <Typography variant="Title_Looko">{children}</Typography>
    </ContainerH>
  );
};
